import { CommonModule } from '@angular/common';
import { Component, Input, inject, Output, EventEmitter } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageService } from 'primeng/api';
import { MeetingService } from '@/app/plateformebeneficiaire/core/service/meeting.service';
import { environment } from '../../../../../environments/environment';
import { MeetingEvent } from '@/app/plateformebeneficiaire/core/models/meetings.model';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-meeting-item-card',
  imports: [
    CommonModule,
    ButtonModule,
    Dialog,
    ProgressSpinnerModule,
    TooltipModule
  ],
  templateUrl: './meetings-item-card.component.html',
  styleUrl: './meetings-item-card.component.scss'
})
export class MeetingsItemCardComponent {
  constructor(private messageService: MessageService) {}
  @Input() meeting: any = {};
  @Input() past: boolean = false;
  @Output() updateMeetingEvent = new EventEmitter<any>();

  jourNumero: string = '';
  moisLibelle: string = '';
  heure: string = '';

  allowCancel: boolean = false;
  deleteDialogVisible: boolean = false;
  isLoading: boolean = false;

  #meetingService = inject(MeetingService);

  ngOnInit(): void {
    var date = new Date(this.meeting.dateTimeDebut);
    this.jourNumero = date.toLocaleString('fr-FR', { day: '2-digit' });
    this.moisLibelle = date.toLocaleString('fr-FR', { month: 'long' });
    this.heure = date.toLocaleTimeString('fr-FR', {hour: '2-digit', minute:'2-digit'}).replace(':', 'h');

    const now = Date.now();
    const timeDiff = date.getTime() - now; // en ms
    const hoursDiff = timeDiff / (1000 * 60 * 60); // conversion en heures

    this.allowCancel = hoursDiff >= environment.hoursBeforeDeleteRdv;
  }
  
  updateMeeting() {
    this.updateMeetingEvent.emit(this.meeting);
  }

  deleteMeeting() {
    this.isLoading = true;

    this.#meetingService.deleteMeeting.mutate({ meetingId: this.meeting.id }, {
      onSuccess: () => {      
        this.messageService.add({ key: 'global', severity: 'success', summary: 'Supprimé !', detail: 'Votre rendez-vous est annulé !' });
        this.isLoading = false;
        this.deleteDialogVisible = false;
      },
      onError: (error) => {
        this.messageService.add({ key: 'global', severity: 'error', summary: 'Erreur', detail: 'Erreur lors de l\'annulation du rendez-vous' });
        this.isLoading = false;
        this.deleteDialogVisible = false;
      }
    });
  }

  openVisioLink(meeting: MeetingEvent) {
    if (meeting.visioLink) {
      window.open(meeting.visioLink + "?lang=fr", '_blank');
    } else {
      this.messageService.add({ key: 'global', severity: 'warn', summary: 'Lien visio manquant', detail: 'Aucun lien de visio disponible pour ce rendez-vous.' });
    }
  }

  showDeleteDialog() {
    this.deleteDialogVisible = true;
  }
}
